import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import PerfectScrollbar from 'react-perfect-scrollbar';
import moment from 'moment';
import 'moment/locale/pt-br';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import SettingsIcon from '@material-ui/icons/Settings';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

import {
    Breadcrumbs,
    Button,
    Box,
    Card,
    CardActions,
    CardContent,
    CircularProgress,
    Grid,
    Link,
    Typography,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
    TableContainer,
    IconButton,
    MenuItem,
    Menu,
    ListItemIcon,
    ListItemText,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core';
import api from '../../../services/api';
import { hasAccess } from '../../../services/auth';

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(3),
    },
    content: {
        marginTop: theme.spacing(2),
    },
    breadCrumb: {
        color: theme.secondary,
        fontSize: '11px',
        fontWeight: 500,
        letterSpacing: '0.33px',
        lineHeight: '13px',
        textTransform: 'uppercase',
    },
    paper: {
        borderRadius: '4px',
        alignItems: 'center',
        padding: theme.spacing(1),
        display: 'flex',
        flexBasis: 420,
    },
    input: {
        flexGrow: 1,
        fontSize: '14px',
        lineHeight: '16px',
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
    },
    container: {
        maxHeight: 450,
    },
    autocomplete: {
        backgroundColor: 'white',
        // height: '45.625px'
    },
    papers: {
        padding: theme.spacing(1),
        textAlign: 'center',
        color: theme.palette.text.secondary,
        whiteSpace: 'nowrap',
        marginBottom: theme.spacing(1),
    },
}));

const TreinamentoPresencialList = () => {
    const acessoAdmin = hasAccess("Configuracoes", "Parceiros");
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [currentPage, setCurrentPage] = useState(0);
    const [perPage, setPerPage] = useState(10);
    const [paginationInfo, setPaginationInfo] = useState({
        pages: 0,
        total: 0,
    });
    const [anchorEl, setAnchorEl] = useState(null);
    const [treinamentos, setTreinamentos] = useState([]);
    const [loading, setLoading] = useState(false);
    const isSmallScreen = useMediaQuery('(max-width:600px)');
    const [treinamento, setTreinamento] = useState({});
    const [isOpenExcluirTreinamento, setIsOpenExcluirTreinamento] = useState(false);
    const open = Boolean(anchorEl);
    const handleCurrentPageChange = (event, page) => {
        setCurrentPage(page);
    };
    const handlePerPageChange = (event) => {
        setCurrentPage(0);
        setPerPage(event.target.value);
    };
    const getTreinamentos = async() =>{
        try{
            setLoading(true);
            const response = await api.get('/treinamento',{
                params: {
                    currentPage: currentPage + 1,
                    perPage
                }
            });
            setPaginationInfo({
                pages: response.data.pagination.lastPage,
                total: response.data.pagination.total,
            });
            setTreinamentos(response.data.data);
            setLoading(false);
        }catch(err){
            setLoading(false);
            enqueueSnackbar(err, {
                variant: 'error',
            });
        }
    }

    const handleExcluirTreinamento = async () => {
        try {
            setAnchorEl(null);
            handleCloseExcluirTreinamento();
            await api.delete(`/treinamento/${treinamento.treinamento_id}`);
            await getTreinamentos();
            enqueueSnackbar('Treinamento removido com sucesso!', {
                variant: 'success',
            });
        } catch (error) {
            if (error.response) {
                enqueueSnackbar(error.response.data.error, {
                    variant: 'error',
                });
            }
        }
    };
    useEffect(() => {
        getTreinamentos();
    },[currentPage, perPage])

    const openMenuActions = (event, modulo) => {
        setAnchorEl(event.currentTarget);
        setTreinamento(modulo);
    };

    const closeMenuActions = () => {
        setAnchorEl(null);
    };
    const handleOpenExcluirTreinamento = async () => {
        setIsOpenExcluirTreinamento(true);
        setAnchorEl(null);
    };
    const handleCloseExcluirTreinamento = async () => {
        setIsOpenExcluirTreinamento(false);
    };

    return (
        <div className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={6}>
                    <Breadcrumbs
                        className={classes.breadCrumb}
                        aria-label="breadcrumb"
                        gutterBottom
                    >
                        <Link
                            color="inherit"
                            component={RouterLink}
                            to="/admin/"
                        >
                            Home
                        </Link>
                        <Typography className={classes.breadCrumb}>
                            Presencial
                        </Typography>
                    </Breadcrumbs>
                    <Typography variant="h3" component="h1">
                        Controle De Treinamentos Presenciais
                    </Typography>
                </Grid>
                <Grid container xs={6} justify="flex-end" alignItems="center">
                    <Button
                        component={RouterLink}
                        to="/admin/treinamento/presencial/novo"
                        color="primary"
                        variant="contained"
                    >
                        Cadastrar Treinamento
                    </Button>
                </Grid>
            </Grid>

            <Box mt={4}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Card>
                            <CardContent
                                style={{
                                    padding: 0,
                                }}
                            >
                                <PerfectScrollbar>
                                    <TableContainer
                                        className={
                                            isSmallScreen && classes.container
                                        }
                                    >
                                        <Table stickyHeader>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell>Nome</TableCell>
                                                    <TableCell>Setor</TableCell>
                                                    <TableCell>Data</TableCell>
                                                    <TableCell>Presentes</TableCell>
                                                    <TableCell>Quantidade de alunos</TableCell>
                                                    { acessoAdmin.visualizar && (
                                                        <TableCell>Parceiro</TableCell>
                                                    )}
                                                    <TableCell></TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {loading ? (
                                                    <TableRow>
                                                        <TableCell
                                                            align="center"
                                                            colSpan={6}
                                                        >
                                                            <CircularProgress />
                                                        </TableCell>
                                                    </TableRow>
                                                    ) : (
                                                        <>
                                                            {treinamentos.length == 0 ? 
                                                                <TableRow>
                                                                    <TableCell
                                                                        align="center"
                                                                        colSpan={5}
                                                                    >
                                                                        Nenhum registro existente
                                                                    </TableCell>
                                                                </TableRow>
                                                            :
                                                            treinamentos.map(item =>
                                                                <TableRow key={item.treinamento_id}>
                                                                    <TableCell>{item.nome}</TableCell>
                                                                    <TableCell>{item.nome_grupo}</TableCell>
                                                                    <TableCell>{item.data ? moment(item.data).format('DD/MM/YYYY') : '--/--/----'}</TableCell>
                                                                    <TableCell>{item.presentes?.toFixed(2)}%</TableCell>
                                                                    <TableCell>{item.quantidade_aluno}</TableCell>
                                                                    { acessoAdmin.visualizar && (
                                                                        <TableCell>
                                                                        {
                                                                            item.nome_parceiro ? item.nome_parceiro : '-'
                                                                        }
                                                                    </TableCell>
                                                                    )
                                                                    }
                                                                    <TableCell align="right">
                                                                        <IconButton
                                                                            size="small"
                                                                            color="secondary"
                                                                            aria-label="more"
                                                                            aria-controls="long-menu"
                                                                            aria-haspopup="true"
                                                                            onClick={(
                                                                                e
                                                                            ) =>
                                                                                openMenuActions(
                                                                                    e,
                                                                                    item
                                                                                )
                                                                            }
                                                                        >
                                                                            <SettingsIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                                )
                                                            }
                                                        </>
                                                    )
                                                }
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </PerfectScrollbar>
                            </CardContent>
                            <CardActions
                                style={{
                                    justifyContent: 'flex-end',
                                }}
                            >
                                <TablePagination
                                    component="div"
                                    count={paginationInfo.total}
                                    onChangePage={handleCurrentPageChange}
                                    onChangeRowsPerPage={handlePerPageChange}
                                    page={currentPage}
                                    rowsPerPage={perPage}
                                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                                />
                            </CardActions>
                        </Card>
                    </Grid>
                </Grid>
            </Box>

            <Menu
                anchorEl={anchorEl}
                keepMounted
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                open={open}
                onClose={closeMenuActions}
            >
                <MenuItem
                    component={RouterLink}
                    to={`/admin/treinamento/presencial/editar/${treinamento.treinamento_id}`}
                >
                    <ListItemIcon
                        style={{
                            minWidth: '32px',
                        }}
                    >
                        <EditIcon color="secondary" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Editar" />
                </MenuItem>
                <MenuItem onClick={handleOpenExcluirTreinamento}>
                    <ListItemIcon style={{ minWidth: '32px' }}>
                        <DeleteIcon color="secondary" fontSize="small" />
                    </ListItemIcon>
                    <ListItemText primary="Excluir" />
                </MenuItem>
            </Menu>

            <Dialog
                open={isOpenExcluirTreinamento}
                onClose={handleCloseExcluirTreinamento}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">
                    Exclusão de Treinamento
                </DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        O Treinamento será excluído, deseja continuar?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseExcluirTreinamento} color="primary">
                        Cancelar
                    </Button>
                    <Button onClick={handleExcluirTreinamento} color="primary">
                        Excluir
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
};

export default TreinamentoPresencialList;
